<template>
  <div class="bg-black w-[70px] h-[70px] rounded-full cursor-pointer" @click="emit('toggle')">
    <div class="relative flex h-full w-full items-center justify-center">
      <p
        v-if="safeNewMsgCount > 0"
        class="absolute -top-2 -right-2 w-7 h-7 flex items-center justify-center text-white font-bold bg-orange rounded-full border-2 border-white"
      >
        {{ safeNewMsgCount }}
      </p>

      <SvgoIconComponentChatIconMsg v-if="!open"></SvgoIconComponentChatIconMsg>
      <SvgoIconComponentChatIconClose v-else=""></SvgoIconComponentChatIconClose>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue"

const props = withDefaults(defineProps<{
  open?: boolean
  newMsgCount?: number
}>(), {
  open: false,
  newMsgCount: 0,
})

const emit = defineEmits<{
  (e: "toggle"): void
}>()

const safeNewMsgCount = computed(() => {
  const value = Number(props.newMsgCount)
  if (!Number.isFinite(value) || value <= 0) return 0
  return Math.floor(value)
})
</script>
